import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Home } from "lucide-react";
import Logo from "../../../assets/images/logonav.svg";

// Catch-all for any unmatched route — wired up as the last entry in
// routes/index.tsx's useRoutes() array ({ path: "*", element: <NotFound /> }).
const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 dark:from-gray-950 dark:via-gray-950 dark:to-gray-950 px-6">
      <div className="text-center max-w-md">
        <img src={Logo} alt="ConvoHub" className="h-7 mx-auto mb-10" />

        <p className="text-7xl font-bold bg-gradient-to-r from-indigo-600 to-blue-600 bg-clip-text text-transparent">404</p>
        <h1 className="mt-3 text-xl font-semibold text-slate-800 dark:text-gray-100">Page not found</h1>
        <p className="mt-2 text-sm text-slate-500 dark:text-gray-400">
          The page you're looking for doesn't exist or may have been moved.
        </p>

        <div className="mt-8 flex items-center justify-center gap-3">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 px-4 py-2.5 rounded-xl border border-slate-200 dark:border-gray-700 text-sm font-medium text-slate-600 dark:text-gray-300 hover:bg-white dark:hover:bg-gray-900 transition-colors"
          >
            <ArrowLeft size={15} /> Go back
          </button>
          <button
            onClick={() => navigate("/")}
            className="flex items-center gap-2 px-4 py-2.5 rounded-xl bg-indigo-600 hover:bg-indigo-700 text-sm font-medium text-white shadow-sm transition-colors"
          >
            <Home size={15} /> Go home
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
